import { Heart, Unlock } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import Image from '~/components/common/Image';
import { appAssetsCdnUrl } from '~/constants/environment';
import {
  Amount,
  Card,
  Container,
  Content,
  Copy,
  Disclaimer,
  Favorite,
  ImageContainer,
  Monthly,
  Payment,
  PriceDetails,
  Rectangle,
  Rectangle3,
  Rectangle4,
  Skeletons,
  Vehicle,
  VehicleImage,
  VehicleSliderContainer
} from './VehicleSlider.styles';

const InfiniteSlider = dynamic(() => import('./InfiniteSlider'), {
  ssr: false
});

type TransitionProps = {
  currentChild: number;
};

const dataItems = [
  {
    image: `${appAssetsCdnUrl}/images/flp/vehicle-slider-car-1.png`,
    priceDetail: 645
  },
  {
    image: `${appAssetsCdnUrl}/images/flp/vehicle-slider-car-2.png`,
    priceDetail: 350
  },
  {
    image: `${appAssetsCdnUrl}/images/flp/vehicle-slider-car-3.png`,
    priceDetail: 446
  },
  {
    image: `${appAssetsCdnUrl}/images/flp/vehicle-slider-car-4.png`,
    priceDetail: 565
  },
  {
    image: `${appAssetsCdnUrl}/images/flp/vehicle-slider-car-5.png`,
    priceDetail: 475
  }
];

const getPriceDetails = (childIndex: number) => {
  childIndex = childIndex >= dataItems.length ? 0 : childIndex;

  return dataItems[childIndex].priceDetail;
};

function VehicleSlide({ image }: { image: string }) {
  return (
    <Card>
      <ImageContainer>
        <Rectangle>
          <Favorite>
            <Heart aria-hidden="true" color="white" size={16} />
          </Favorite>
          <Vehicle>
            <VehicleImage>
              <Image src={image} alt="Carousel Item" />
            </VehicleImage>
          </Vehicle>
        </Rectangle>
      </ImageContainer>

      <Content>
        <Skeletons>
          <Rectangle3 />
          <Rectangle4 />
        </Skeletons>
      </Content>
    </Card>
  );
}

export default function VehicleSlider() {
  const [showPriceDetails, setShowPriceDetails] = useState<boolean>(true);
  const [priceDetail, setPriceDetail] = useState<number>(
    dataItems[2].priceDetail
  );

  const onTransitionStart = () => {
    setShowPriceDetails(false);
  };

  const onTransitionEnd = ({ currentChild }: TransitionProps) => {
    setPriceDetail(getPriceDetails(currentChild));
    setShowPriceDetails(true);
  };

  return (
    <VehicleSliderContainer>
      <Container>
        <InfiniteSlider
          delay={4000}
          transformDuration={800}
          onTransitionStart={onTransitionStart}
          onTransitionEnd={onTransitionEnd}
        >
          {dataItems.map(({ image }) => (
            <VehicleSlide key={image} image={image} />
          ))}
        </InfiniteSlider>

        <PriceDetails show={showPriceDetails}>
          <Unlock className="shrink-0" color="white" size={27} />
          <Copy>
            <Payment>Real Payment</Payment>
            <Amount>
              ${priceDetail.toLocaleString()}
              <Monthly>/mo*</Monthly>
            </Amount>
          </Copy>
        </PriceDetails>
      </Container>
      <Disclaimer>
        <p>
          *All sample rates based on a well-qualified buyer with an APR of 6.99%
          at 75 months with $0 down payment.
        </p>
      </Disclaimer>
    </VehicleSliderContainer>
  );
}
